import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DBTalkerPage from './pages/DBTalkerPage';
import DocFlowAIPage from './pages/DocFlowAIPage';
import VisionEdgeAIPage from './pages/VisionEdgeAIPage';
import BlockchainWalletPage from './pages/BlockchainWalletPage';
import EdgeSpherePage from './pages/EdgeSpherePage';
import InfluenceHubAIPage from './pages/InfluenceHubAIPage';
import FAQPage from './pages/FAQPage';
import ModelsByIndustryPage from './pages/ModelsByIndustryPage';
import LicensePage from './pages/LicensePage';
import MeetingSchedulerPage from './pages/MeetingSchedulerPage';
import Header from './components/Header';
import Footer from './components/Footer';
import ROICalculator from './components/ROICalculator';
import PlatformArchitecture from './components/PlatformArchitecture';
import AIEvolution from './components/AIEvolution';
import './App.css';

function App() {
  console.log('🚀 App component rendered');
  
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/db-talker" element={<DBTalkerPage />} />
            <Route path="/docflow-ai" element={<DocFlowAIPage />} />
            <Route path="/visionedge-ai" element={<VisionEdgeAIPage />} />
            <Route path="/blockchain-wallet" element={<BlockchainWalletPage />} />
            <Route path="/edgesphere" element={<EdgeSpherePage />} />
            <Route path="/influencehub-ai" element={<InfluenceHubAIPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/models-by-industry" element={<ModelsByIndustryPage />} />
            <Route path="/license" element={<LicensePage />} />
            <Route path="/schedule-meeting" element={<MeetingSchedulerPage />} />
            <Route path="/roi-calculator" element={<ROICalculator />} />
            <Route path="/architecture" element={<PlatformArchitecture />} />
            <Route path="/ai-evolution" element={<AIEvolution />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
